module.exports = __webpack_public_path__ + "60eb012fb8a7c8f4c3ce6677890ba56e.pdf";